// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {clsx} from 'clsx';
import React from 'react';
import TimeAgo from 'react-timeago';

import {useRampFlagStarredProjects} from '../../../util/rampFeatureFlags';
import {StarredProjectsContext} from '../../../util/StarredProjectsContextProvider';
import {maybePluralize} from '../../../util/uihelpers';
import * as C from './CommonCards.styles';
import * as S from './ProjectCards.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {type HomePageProject} from './util';

type ProjectCardsProps = {
  projects: HomePageProject[];
};

const ProjectCard: React.FC<{
  project: HomePageProject;
}> = ({project}) => {
  const {id, url, name, runCount, lastActive, description} = project;
  const runsCountText = maybePluralize(runCount, 'run');
  const {starredProjects, onStarClick} = React.useContext(
    StarredProjectsContext
  );
  const isStarred = starredProjects[id] !== undefined;
  const isStarredProjectsEnabled = useRampFlagStarredProjects();
  return (
    <S.Card
      key={id}
      to={url}
      className="group"
      data-test={`project-card-${name}`}>
      <S.CardHeaderRow>
        <S.CardHeader>{name}</S.CardHeader>
        {isStarredProjectsEnabled && (
          <Button
            className={clsx('ml-8', isStarred ? '' : 'hidden group-hover:flex')}
            size="medium"
            variant="ghost"
            icon={isStarred ? 'star-filled' : 'star'}
            data-test={`star-button-${name}`}
            aria-label={isStarred ? 'Unstar project' : 'Star project'}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              onStarClick(project, !isStarred, 'project cards');
            }}
          />
        )}
      </S.CardHeaderRow>
      <C.CardDescription>{description}</C.CardDescription>
      <S.CardMeta>
        <S.UpdatedAtIcon role="presentation" />
        <S.ClampedLine>
          Last updated {<TimeAgo date={lastActive} />}
        </S.ClampedLine>
        <S.RunsIcon role="presentation" />{' '}
        <S.ClampedLine>{runsCountText}</S.ClampedLine>
      </S.CardMeta>
    </S.Card>
  );
};

export const ProjectCards: React.FC<ProjectCardsProps> = props => {
  const projectCards = props.projects.map(project => (
    <ProjectCard key={project.id} project={project} />
  ));
  return <C.Grid numColumns={4}>{projectCards}</C.Grid>;
};
